import React from "react";
import { number, array, func, string } from "prop-types";

import "./collectionNameTabs.m.css";

const CollectionNameTabs = ({ collectionList, selectedIndex = 0, onTabClick, className = "" }) => {
  return (
    <div styleName="base" className={className}>
      {collectionList.map((headline, index) => (
        <h2
          key={index}
          onClick={() => onTabClick(index)}
          className={`${selectedIndex === index ? "active-tab" : ""} ${"tab-headline"}`}
        >
          {headline}
        </h2>
      ))}
    </div>
  );
};

CollectionNameTabs.propTypes = {
  collectionList: array.isRequired,
  selectedIndex: number,
  onTabClick: func,
  className: string,
};

export default CollectionNameTabs;
